import React from 'react';
import usePages from '../../../../hooks/usePages';
import { useGetAllContactsByShareToken } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { buildPaginationFromResponse } from '../../../../services/pagination';
import ContactsTable from '../../ContactsTable/ContactsTable';
import { useInspectionDetailShareContext } from '../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
const ContactsShareContent = ({ inspection }) => {
    const { token } = useInspectionDetailShareContext();
    const { incrementPage, decrementPage, page } = usePages();
    const { data: response, isFetching } = useGetAllContactsByShareToken(token, {
        should_paginate: 1,
        page,
    });
    const contacts = unwrapModel(response);
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    return (React.createElement(ContactsTable, { inspection: inspection, canEditContacts: false, isFetching: isFetching, contacts: contacts, pagination: pagination }));
};
export default ContactsShareContent;
